import { render } from "./ConfirmationForm.vue?vue&type=template&id=e843264a"
import script from "./ConfirmationForm.vue?vue&type=script&lang=js"
export * from "./ConfirmationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__